import { render, staticRenderFns } from "./newMaterialTag.vue?vue&type=template&id=511bb3f2&scoped=true&"
import script from "./newMaterialTag.vue?vue&type=script&lang=js&"
export * from "./newMaterialTag.vue?vue&type=script&lang=js&"
import style0 from "./newMaterialTag.vue?vue&type=style&index=0&id=511bb3f2&lang=less&scoped=true&"
import style1 from "./newMaterialTag.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511bb3f2",
  null
  
)

component.options.__file = "newMaterialTag.vue"
export default component.exports